import React, { useState, useMemo, useEffect } from 'react'

import { Dialog, DialogContent, DialogActions, DialogTitle, Box, Button, Typography, Grid2 } from "@mui/material";
import { Form, Formik } from 'formik';
import { myApi } from '../../../config/axiosConfig';
import { useDropzone } from "react-dropzone"
import * as XLSX from 'xlsx'
import Swal from 'sweetalert2';
import imgXls from "../../../assets/img/xlsx_icon.svg"
import Cookies from 'js-cookie';

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#1f2a40',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#1f2a40',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};
  
  const acceptStyle = {
    borderColor: '#00e676'
};
  
  const rejectStyle = {
    borderColor: '#ff1744'
};

function SubirPrice({ open, onClose }) {

const [datos, setdatos] = useState([]);
const [acceptedFiles, setAcceptedFiles] = useState([]); 
    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({
        accept: {'application/vnd.ms-excel': [], 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': []},
        maxFiles: 1,
        onDrop:(acceptedFiles) => {
            setAcceptedFiles(acceptedFiles); 
            const reader = new FileReader();
    
            reader.onload = (e) => {
              const data = e.target.result;
              const workbook = XLSX.read(data, { type: 'binary' });
              const sheetName = workbook.SheetNames[0];
              const sheet = workbook.Sheets[sheetName];
              const jsonData = XLSX.utils.sheet_to_json(sheet);
    
              setdatos(jsonData)
            };
        
            reader.readAsBinaryString(acceptedFiles[0]);
        }
    });
    
    const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

   const handleSubmit = () =>{
        if(datos.length !== 0){

            Swal.fire({
                icon: 'info',
                title: "Cargando...",
                allowOutsideClick: false, // Evita que se cierre haciendo clic fuera
                showConfirmButton: false, // Para evitar que el usuario cierre el mensaje
            });

            myApi.post('/fuel_report/post/CargaPrice', {...datos, usuario: Cookies.get('ebt_nombre')})
            .then((response) => {
                if (response.data.success !== true) 
                {
                    throw new Error(response.data.error || 'No se pudo cargar el archivo');
                }
                console.log("Cargado", response.data); 
                Swal.close();
                Swal.fire({
                    icon: 'success',
                    title: '¡Archivo procesado!',
                    text:
                        `Nuevos con OPIS: ${response.data.insertadosConOpis}. ` +
                        `Nuevos sin OPIS: ${response.data.insertadosSinOpis}.`,
                    target: document.getElementById('dialog1')
                }).then(() => {
                    onClose();
                });         
            })
            .catch((error) => {
                console.log("ocurrio un error: " +error);
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: "¡Ocurrió un error!",
                    target: document.getElementById('dialog1')
                });
            }) 
            .finally(() => {
                setdatos([]);
            });     
            /*
            Swal.fire({
                icon: 'success',
                title: "¡Archivo Cargado!",
            })
            setdatos([]);
            */
        }
        else
        {
            Swal.fire({
                icon: 'error',
                title: "¡Seleccione un archivo!",
                target: document.getElementById('dialog1')
            })
        }
    }

    useEffect(() => {
        if (open) 
        {
            setAcceptedFiles([]);  
        }
    }, [open]);  

    const initialValues = {
            datos: datos
        };

  return (
    <Dialog id="dialog1" open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle>Cargar Info de Prices de LOVE'S</DialogTitle>
        <DialogContent>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
            >
                {({ handleSubmit }) => (
                    <Form onSubmit={handleSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <Grid2 container spacing={2} style={{ flexGrow: 1 }}>
                            <Grid2 size={{ xs: 12, sm: 12 }}>
                                <Box m="20px 0 0 0"
                                    height="25vh"
                                    width="100%">
                                    <div {...getRootProps({style})}>
                                        <input {...getInputProps()} />
                                        <p>Arrastre el archivo aquí o de clic para seleccionar el archivo.</p>
                                    </div>
                                    <aside>
                                    <h4>
                                    <p>Archivo Cargado:</p>
                                    </h4>                
                                    <ul id='listaArchivo'>
                                        {acceptedFiles.map(file => (
                                        <li key={file.path}>
                                            <Typography>
                                            <img src={imgXls} style={{height: '20px'}}></img> {file.path} - {file.size} bytes
                                            </Typography>
                                        </li>
                                        ))}
                                    </ul>
                                    </aside>              
                                </Box>  
                            </Grid2>             
                            <DialogActions style={{ justifyContent: 'flex-end', marginTop: 'auto' }}>
                                <Button type="submit" variant="contained" color="primary">
                                    Subir
                                </Button>
                                <Button onClick={onClose}>Cancelar</Button>
                            </DialogActions>
                        </Grid2>
                    </Form>
                )}
            </Formik>
         </DialogContent>
    </Dialog>
  )
}

export default SubirPrice